"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    r = require("react"),
    t = (e = r) && "object" == typeof e && "default" in e ? e["default"] : e;

exports["default"] = r.forwardRef(function (e, r) {
  return t.createElement("span", Object.assign({
    ref: r,
    style: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }
  }, e));
});